import React, { Component } from "react";
import ReactLoading from 'react-loading';
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api";
import {login,setNewToken}  from "../../services/auth";

class OAuth extends Component {
    state = {

    };

    componentDidMount(){
       // var parametros = this.props.match.params;

       //var token =window.location.href.replace("https://www.voitto.com.br/OAuth/?", "");
        
        var json = window.location.href.replace("http://localhost:81/OAuth?", "");
        json = json.replace("https://www.voitto.com.br/OAuth?", "");
  
        json = json.split('|');
                
        var token = json[0].replace("https://www.voitto.com.br/OAuth/?","");
        var redirect = json[1] !== '' && json[1] !== undefined?json[1]:null;

        if(token.lenght <=0 ||token === '' ||  token === undefined){
            window.location.replace("https://voitto.com.br"+redirect);
            return;
        }
    
        if(login(token)){
            const localStorageRedirect = localStorage.getItem('redirect')
            if(localStorageRedirect){
                window.location.href=localStorageRedirect
                localStorage.removeItem('redirect')
                return;
            }

            if(redirect != undefined && redirect != null){
                window.location.replace(redirect);
                return;
            }else{
                window.location.replace("https://voitto.com.br/cursos");
            }
           
            return;
        }
    }
   
    render() {
        return(
            <div style={{alignContent:'center', backgroundColor:'#242424',justifyContent:'center',paddingTop:'20%', paddingBottom:'32%'}}>
                <center>
                    <ReactLoading type={'bars'} color={'white'} height={'5%'} width={'5%'}  />
                </center>
            </div>
        )
    }
     

}

export default withRouter(OAuth);